module.exports = __webpack_public_path__ + "img/dj.93bc8593.svg";